import { ajax } from "@/assets/js/ajax";
export function debtorLists(data) {
  //债务人列表
  return ajax({
    url: "debtor/lists",
    type: "get",
    data: data,
  });
}

export function captcha() {
  //图形验证码
  return ajax({
    url: "auth/captcha",
    type: "get",
  });
}

export function indexWithDetail() {
  return ajax({
    url: "indexWithDetail",
    type: "get",
  });
}
export function getcause(data) {
  //案件列表
  return ajax({
    url: "cause/index",
    type: "get",
    data: data,
  });
}

export function getCauseList(data) {
  //案件列表
  return ajax({
    url: "cause/lists",
    type: "get",
    data: data,
  });
}

export function causeStep(data) {
  //进度列表
  return ajax({
    url: "step/lists",
    type: "get",
    data: data,
  });
}
export function stepCredit(data) {
  return ajax({
    url: "step/proposition_credit",
    type: "get",
    data: data,
  });
}
export function sendCredit(data) {
  return ajax({
    url: "cause/credit/add",
    data: data,
    contentType: "application/json",
  });
}
export function accuseList(data) {
  //原告
  return ajax({
    url: "accuser/index",
    type: "get",
    data: data,
  });
}
export function debtorAll(data) {
  //债务人
  return ajax({
    url: "debtor/all",
    type: "get",
    data: data,
  });
}

export function CourtList(data) {
  //管辖法院
  return ajax({
    url: "cause/court",
    type: "get",
    data: data,
  });
}
export function getDistricts() {
  //省市区
  return ajax({
    url: "districts/pca",
    type: "get",
  });
}

export function getAccuserAll() {
  //所有原告列表
  return ajax({
    url: "accuser/all",
    type: "get",
  });
}

export function repass(data) {
  //修改密码
  return ajax({
    url: "user/password",
    type: "post",
    data: data,
  });
}
export function debtorClear(data) {
  return ajax({
    url: "debtor/clear",
    data: data,
  });
}
export function delCause(data) {
  return ajax({
    url: "cause/delete",
    data: data,
    type: "get",
  });
}
export function invaildList(data) {
  return ajax({
    url: "statis/causeInvaild/index",
    data: data,
    type: "get",
  });
}

export function delInvaild(data) {
  return ajax({
    url: "cause/invaild",
    data: data,
    type: "get",
  });
}

export function rCard(data) {
  return ajax({
    url: "debtor/unique",
    data: data,
    type: "get",
  });
}
export function cxPost(data) {
  return ajax({
    url: "credit/payee/cancel",
    data: data,
  });
}

export function rFileName(data) {
  //修改附件名字
  return ajax({
    url: "step/file/edit",
    data: data,
  });
}

export function carAdd(data) {
  //车型新增
  return ajax({
    url: "car/add",
    data: data,
  });
}

export function carList(data) {
  //车型列表
  return ajax({
    url: "car/index",
    data: data,
    type: "get",
  });
}

export function carEdit(data) {
  //车型修改
  return ajax({
    url: "car/edit",
    data: data,
  });
}
export function carDel(data) {
  //车型修改
  return ajax({
    url: "car/del",
    data: data,
    type: "get",
  });
}

export function reasonAdd(data) {
  //案由新增
  return ajax({
    url: "reason/add",
    data: data,
  });
}

export function reasonList(data) {
  //案由列表
  return ajax({
    url: "reason/index",
    data: data,
    type: "get",
  });
}

export function reasonEdit(data) {
  //案由修改
  return ajax({
    url: "reason/edit",
    data: data,
  });
}

export function reasonDel(data) {
  //车型修改
  return ajax({
    url: "reason/del",
    data: data,
    type: "get",
  });
}

export function overList(data) {
  //案由列表
  return ajax({
    url: "over/remind",
    data: data,
    type: "get",
  });
}

export function overEdit(data) {
  //案由修改
  return ajax({
    url: "over/edit",
    data: data,
  });
}

export function overSet(data) {
  //超期设置
  return ajax({
    url: "over/index",
    data: data,
    type: "get",
  });
}

export function Delay(data) {
  //超期设置
  return ajax({
    url: "over/delay",
    data: data,
  });
}

export function risk(data) {
  return ajax({
    url: "statis/risk",
    data: data,
    type: "get",
  });
}

export function overLists(data) {
  return ajax({
    url: "over/lists",
    data: data,
    type: "get",
  });
}

export function download(id) {
  //id、
  window.open(`upload/download?id=${id}`);
}

//over/lists?cause_id=26&step=3&limit=10&page=1

export function refundAdd(data) {
  return ajax({
    url: "cause/refund/add",
    data: data,
    contentType: "application/json",
    type: "post",
  });
}

export function refundList(data) {
  return ajax({
    url: "cause/refund/index",
    data: data,
    type: "get",
  });
}

export function bankClearFee(data) {
  return ajax({
    url: "cause/bank_clear_fee",
    data: data,
  });
}

export function wread(
  id, // ID
  type, // 当前栏目类型
  s
) {
  //  是否是特殊
  let url,
    data,
    contentType = "application/json",
    types = "post";
  if (type == 0) {
    // url = s == 2 ? 'actionLog/read' : 'cause/comments/read'
    // data = s == 2 ? { ids: id } : { id: id.toString() }
    // contentType = s == 2 ? 'application/json' : 'application/x-www-form-urlencoded'
    // types = s == 2 ? 'post' : 'get'
    url = "cause/comments/read";
    data = { id: id.toString() };
    contentType = "application/x-www-form-urlencoded";
    types = "get";
  } else if (type == 1) {
    url = "actionLog/read";
    data = { ids: id };
  } else if (type == 2) {
    url = "debtor/newDebtorRemind/read";
    data = { debtor_id: id };
  } else {
    url = "shipRemind/read";
    data = { id: id };
  }
  return ajax({
    url: url,
    data: data,
    contentType: contentType,
    type: types,
  });
}

export function wsee(data) {
  return ajax({
    url: "cause/comments/see",
    data: data,
    type: "get",
  });
}

// export function outForm (type, query) {
//   const url = {
//     0: 'export/ssxxzb',   //案件信息总表
//     1: 'export/fqxxb',    //分期信息表
//     2: 'export/hkxxb',    //回款信息表
//     3: 'export/dqjdb',    //当前进度表
//     4: 'export/lsjdb',     //历史进度表
//     5: 'export/cpwsb',
//     6: 'export/cpjssdlrb',
//     7: 'export/ssfyjnjtfb'
//   }
//   return url[type] + "?" + query
// }

export function outForm(type, query) {
  const url = {
    0: "ssxxzb", //诉讼信息总表-案件统计
    1: "fqxxb", //分期信息表
    2: "hkxxb", //回款信息表
    3: "lsjdb", //历史进度表
    4: "cpwsb", //文书统计
    5: "cpjktdlrb", //传票及诉讼代理人表-开庭统计
    6: "ssfyjnjtfb", //诉讼费用缴纳及退费表-费用统计
  };
  return "excel/" + url[type] + "?" + query;
}

export function todoAdd(data, disType) {
  //添加待办
  return ajax({
    url: disType == 1 ? "todo/add" : "tools/add",
    data: data,
  });
}
export function todoDel(data) {
  return ajax({
    url: "tools/delete",
    data: data,
    type: "get",
  });
}
export function todoUpdate(data, disType) {
  //編輯待办
  return ajax({
    url: disType == 1 ? "todo/update" : "tools/update",
    data: data,
  });
}
export function todoOk(data) {
  return ajax({
    url: "todo/complete",
    data: data,
  });
}
export function delayed(data) {
  return ajax({
    url: "welcome/causeAging/delayed",
    data: data,
  });
}
export function todoInfo(data, disType) {
  //详情
  return ajax({
    url: disType == 0 ? "todo/detail" : "tools/detail",
    data: data,
    type: "get",
  });
}

export function indexHome() {
  return ajax({
    url: "index",
    type: "get",
  });
}

export function cpwsDelay(data) {
  return ajax({
    url: "step/cpws/delay",
    data: data,
  });
}

export function letters(Type, data) {
  return ajax({
    url: "letters/debtor/" + Type,
    type: Type == "index" || Type == "del" ? "get" : "post",
    data: data,
  });
}
export function Ldebtor(Type, data) {
  return ajax({
    url: "letters/" + Type,
    type: Type == "index" || Type == "info" || Type == "del" ? "get" : "post",
    data: data,
  });
}

export function LHis(Type, data) {
  return ajax({
    url: "letters/comment/" + Type,
    type: Type == "del" ? "get" : "post",
    data: data,
  });
}

export function shipRemindDealy(data) {
  return ajax({
    url: "shipRemind/dealy",
    type: "post",
    data: data,
  });
}
export function shipRemindReceive(data) {
  return ajax({
    url: "shipRemind/receive",
    type: "post",
    data: data,
  });
}

export function todoMonth(data) {
  return ajax({
    url: "todo/month",
    type: "get",
    data: data,
  });
}
export function causeStepLog(data) {
  return ajax({
    url: "actionLog/causeStepLog",
    data: data,
    type: "get",
  });
}

export function sLogOutUser(data) {
  return ajax({
    url: "/auth/logout",
    type: "post",
    data: data,
  });
}
